<template>
  <div>
    <section-header heading="2" ja="ARプリクラとは？"/>
    <div class="textArea">
      <p>
        ARプリクラとはセガのプリクラ機で撮影したシールをアプリ内のカメラで写すと、シール上でモーメントを再生する機能です。<br>
        ※シールレイアウトによってモーメントの同時再生可能な上限数が異なる場合があります。
      </p>
      <p>
        撮影ボタンを押すとカメラの画面を動画としてスマホに保存することができます。
      </p>
    </div>
    <section-header heading="2" ja="モーメントを再生できない時は？"/>
    <div class="textArea">
      <p>アルバムに保存してあるシールのみ対象になりますので、先にプリダウンロードしてください。</p>
      <p>モーメントのデータ生成に失敗したためARプリクラをご利用いただけない場合があります。</p>
    </div>
    <section-header heading="2" ja="ARプリクラに関する注意"/>
    <div class="textArea">
      <p>
        撮影した動画をSNS等に投稿する場合、シールIDが映り込まないようにご注意ください。
      </p>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"

export default {
  name: "AboutARpuri",
  components: {
    SectionHeader
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
